import React from 'react'
import { createBrowserRouter } from 'react-router-dom'
import App from '../App'

import AuthLayout from '../layouts/auth-layout'
import AuthNoLayout from '../layouts/auth-no-layout'
import ContentOnlyLayout from '../layouts/content-only/primary-layout'
import MaintenancePage from '../pages/maintenance'
import NotFoundPage from '../pages/not-found'
import { routes } from './routes'
import EnterprisePrimaryLayout from '../layouts/enterprise/primary-layout'

export const contentOnlyRouter = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: routes.login.path,
            lazy: () => import('../pages/sign-in')
          }
        ]
      },
      {
        element: <EnterprisePrimaryLayout />,
        children: [
          {
            path: routes.reporting.path,
            lazy: () => import('../pages/reporting')
          }
        ]
      },
      {
        element: <AuthNoLayout />,
        children: [
          {
            path: routes.maintenance.path,
            element: <MaintenancePage />
          },
          {
            path: routes.signin.path,
            lazy: () => import('../pages/sign-in-completion')
          },
          {
            path: routes.signout.path,
            lazy: () => import('../pages/sign-out-completion')
          },
          {
            path: routes.internalLogin.path,
            lazy: () => import('../pages/admin-internal-login')
          }
        ]
      },
      {
        element: <ContentOnlyLayout />,
        children: [
          {
            path: routes.contentOnlyArticle.path,
            lazy: () => import('../pages/location')
          },
          {
            path: routes.cornerstoneLegacy.path,
            lazy: () => import('../pages/location')
          }
        ]
      },
      {
        path: '*',
        element: <NotFoundPage />
      }
    ]
  }
])
